<script setup lang="ts">
import { NInputNumber } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  value?: number | null
  defaultValue?: number | null
  min?: number
  max?: number
  step?: number
  precision?: number
  size?: 'small' | 'medium' | 'large'
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  clearable?: boolean
  showButton?: boolean
  buttonPlacement?: 'both' | 'right'
  parse?: (input: string) => number
  format?: (value: number | null) => string
  onUpdateValue?: (value: number | null) => void
  onChange?: (value: number | null) => void
  onFocus?: () => void
  onBlur?: () => void
  onClear?: () => void
}>(), {
  value: undefined,
  defaultValue: null,
  min: undefined,
  max: undefined,
  step: 1,
  precision: undefined,
  size: 'medium',
  placeholder: undefined,
  disabled: false,
  readonly: false,
  clearable: false,
  showButton: true,
  buttonPlacement: 'right',
  parse: undefined,
  format: undefined,
})

const emit = defineEmits<{
  'update:value': [value: number | null]
  'change': [value: number | null]
  'focus': []
  'blur': []
  'clear': []
}>()

const attrs = useAttrs()

const onUpdateValue = (value: number | null) => {
  emit('update:value', value)
}

const onChange = (value: number | null) => {
  emit('change', value)
}

const onFocus = () => {
  emit('focus')
}

const onBlur = () => {
  emit('blur')
}

const onClear = () => {
  emit('clear')
}
</script>

<template>
  <!--  <div class="app-input-number w-full" :class="[disabled ? 'app-input-number&#45;&#45;disabled' : '']"> -->
  <NInputNumber
    :value="value"
    :default-value="defaultValue"
    :min="min"
    :max="max"
    :step="step"
    :precision="precision"
    :size="size"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :clearable="clearable"
    :show-button="showButton"
    :button-placement="buttonPlacement"
    :parse="parse"
    :format="format"
    v-bind="attrs"
    @update:value="onUpdateValue"
    @change="onChange"
    @focus="onFocus"
    @blur="onBlur"
    @clear="onClear"
  >
    <template #prefix>
      <slot name="prefix" />
    </template>
    <template #suffix>
      <slot name="suffix" />
    </template>
  </NInputNumber>
<!--  </div> -->
</template>

<style scoped>
/*.app-input-number--disabled :deep(.n-input) {
  opacity: 1 !important;
}

.app-input-number--disabled :deep(.n-input__input-el) {
  opacity: 1 !important;
  font-weight: 500;
  color: #111827 !important;
}

.app-input-number--disabled :deep(.n-input__placeholder) {
  opacity: 1 !important;
  color: #6B7280 !important;
}*/
</style>
